// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ring[data-v-2db37311]{width:137px;height:107px;display:flex;align-items:center;justify-content:center;flex-direction:column;position:relative}.objective-fraction[data-v-2db37311],.subjective-fraction[data-v-2db37311]{position:absolute;font-size:18px;font-weight:700}.objective-fraction>div[data-v-2db37311]:first-child,.subjective-fraction>div[data-v-2db37311]:first-child{margin:0}", ""]);
// Exports
module.exports = exports;
